<template>
    <div>
        <div
            v-for="(item, index) in notifications"
            :key="index"
            class="notification flex justify-between gap-10 px-2 px-sm-3 py-1"
            :class="'notification__color-' + item.status"
            > 
            <div>
                <v-icon v-if="item.status == 'info'" class="mr-2 mb-[.3rem]" color="white">mdi-information-outline</v-icon>
                <v-icon v-if="item.status == 'notifica'" class="mr-2 mb-[.3rem]" color="white">mdi-check</v-icon>
                <v-icon v-if="item.status == 'allert'" class="mr-2 mb-[.3rem]" color="white">mdi-alert-circle</v-icon>
                <v-icon v-if="item.status == 'danger'" class="mr-2 mb-[.3rem]" color="white">mdi-alert-octagram</v-icon>
                <span v-html="item.text"></span>
                <a class="notification--link" :href="item.link" v-if="item.link" target="_blank">- MOSTRA</a>
            </div>
            <v-icon v-if="item.clearable" color="white">mdi-close</v-icon>
        </div>
        <div class="hidden">{{user}}</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
               clear: []
            }
        },
        computed: {
            notifications() {
                let _notifications = []

                // if(this.cant_action == 'bloccato'){

                //     let _text_sospeso = "Il tuo account è stato bloccato"

                //     _notifications.push({text: _text_sospeso, status:'danger' , link:null, clearable: false},)
                // }

                if(this.cant_action == 'sospeso'){

                    let _text_sospeso = "Il tuo account è sospeso"
                    if(this.user.fineSospensione)
                        _text_sospeso = 'Il tuo account è sospeso fino a <b>' + this.formatDate(this.user.fineSospensione, "dddd DD MMMM YYYY") + "</b>"

                    _notifications.push({text: _text_sospeso, status:'allert' , link:null, clearable: false},)
                }

                // if(this.cant_action == 'non_promosso'){
                //     let _text_promosso = "Il tuo account è in fase di validazione"
                //     _notifications.push({text: _text_promosso, status:'allert' , link:null, clearable: false},)
                // }

                return _notifications 
            },
            user() {
                let user = this.$store.getters['user/user']
                return user
            },
            cant_action() {
                let cant_action = this.$store.getters['cant_action']
                return cant_action
            },
        },
    }
</script>

<style lang="scss" scoped>
/*  */
.notification{

  border-bottom: 1px solid $bg-app;

  &__color-{
    &notifica{ background: $succes; color: white; }
    &info{ background: rgb(96, 122, 203); color: white; }
    &allert{ background: #dcae3b; color: white; }
    &danger{ background: orangered; color: white; }
  }

  &--container{
    margin-bottom: 3rem;
  }
  &--link{
    display: inline-block;
    margin-left: 1rem;
    font-weight: 500;
    color: white;
  }

}
</style>